import { TOKEN_LABELS } from '../utils/board.js';

export function TokenSprite({ token, size = 'md', title, className = '', style, ...rest }) {
  return (
    <span
      className={`token-sprite token-sprite--${token} token-sprite--${size} ${className}`}
      role="img"
      aria-label={title ?? TOKEN_LABELS[token]}
      title={title ?? TOKEN_LABELS[token]}
      style={style}
      {...rest}
    />
  );
}
